import React, { useState } from 'react'
import Logo from '../header/images/Logo'
import { useStaticQuery, graphql } from "gatsby"
import Link from '../../utils/link'

function encode(data) {
  return Object.keys(data).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');
}

export default function Contact({ hide,setHide }) {
  const data = useStaticQuery(graphql`
  query  {
    wp {
      siteOptions {
        acf {
          contactMessage
          phone
          email
          linkedin
          instagram
        }
      }
    }
  }
  `)
  const data_contact = data?.wp?.siteOptions?.acf
  const messenger=data_contact?.contactMessage
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [message, setMessage] = useState("")
  const [botField, setBotField] = useState("")
  const [hideForm, setHideForm] = useState(false)
  const [error, setError] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    setError(false)

    fetch('/', {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        'form-name': 'contact',
        'bot-field': botField,
        'first_name': firstName,
        'last_name': lastName,
        'email': email,
        'phone': phone,
        'message': message
      })
    }).then(res => {
      if (!res.ok) throw new Error(`Form submission failed: ${res.status}`)
      // Successfully submitted
      setHideForm(true)
    }).catch(() => {
      setHideForm(false)
      setError(true)
    })
  }
  const props = {
    name: 'contact',
    method: 'POST',
    'data-netlify': 'true',
    'data-netlify-honeypot': 'bot-field',
    onSubmit: handleSubmit
  }
  return (
    <div className={hide === false ? 'wrap_contact active_contact' : "wrap_contact"}>
      <div className='box_fold'>
        <div className='close' onClick={() => setHide(true)}>
          <p>CLOSE</p>
        </div> 
        <div className='wrap_contact__logo'>
          <Logo />
        </div>
        {
          hideForm === false ?
            <div>
              <div className='content_top'>
              </div>
              <div className='content_information'>
                <div className='content_left'>
                  <div className='text_info_top'>
                    <p>
                      <span>Call us</span> —<a href='tel:0413777450'> {data_contact.phone}</a>
                    </p>
                    <p>
                      <span> Email</span> — <i><a href='mailto:admin@finney.net.au'>admin@finney.net.au</a></i>
                    </p>
                  </div>
                  <div className='text_info_bot'>
                    <p>
                      7/17 Chandos St
                    </p>
                    <p>
                      Cheltenham 3192
                    </p>
                  </div>
                </div>
                <div className='content_right'>
                  <p>
                    <Link to={data_contact.linkedin}>LinkedIn</Link>
                  </p>
                  <p>
                    <Link to={data_contact.instagram}>  Instagram</Link>
                  </p>
                </div>
              </div>
              <div className='content_form'>
                <form {...props}>
                  <input type='hidden' name='form-name' value='contact' />
                  <p hidden>
                    <label>
                      Don't fill this out if you're human:{" "}
                      <input
                        name='bot-field'
                        onChange={(e) => setBotField(e.target.value)}
                      />
                    </label>
                  </p>
                  <div className='info_client'>
                    <div className='info_client_left'>
                      <div className='input_text'>
                        <p>First Name</p>
                        <input
                          type='text'
                          name='first_name'
                          onChange={(e) => setFirstName(e.target.value)}
                          required
                        />
                      </div>
                      <div className='input_text'>
                        <p>Last Name</p>
                        <input
                          type='text'
                          name='last_name'
                          onChange={(e) => setLastName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className='info_client_right'>
                      <div className='input_text'>
                        <p>Email Address</p>
                        <input
                          type='email'
                          name='email'
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                      <div className='input_text'>
                        <p>Contact Number</p>
                        <input
                          type='text'
                          name='phone'
                          onChange={(e) => setPhone(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='your_enquiry'>
                    <textarea 
                      name='message' 
                      placeholder='Your Enquiry'
                      onChange={(e) => setMessage(e.target.value)}
                    />
                    <br />
                    <button type='submit'>
                      Send Enquiry
                    </button>
                    {error === true &&
                      <p className='form_error'>
                        Sorry, something went wrong. Please try again or email{" "}
                        <a href='mailto:admin@finney.net.au'>admin@finney.net.au</a>.
                      </p>
                    }
                  </div>
                </form>
              </div>
            </div> :
            <div>
              <div className='form_thanks'>
                <div className='section'>
                  <p>Submitted</p>
                </div>
                <div className='title'>
                  <p>
                    Thanks for your enquiry.
                  </p>
                </div>
                <div className='description' dangerouslySetInnerHTML={{ __html: messenger }}>
                </div>
              </div>
            </div>
        }
      </div>
    </div>
  )
}
